<template>
  <v-card class="mb-12 rich-text">
    <p>
      Read through <a
        href="https://www.lib.cam.ac.uk/digitalpreservation/services/deposit-service"
        target="_blank"
      >Documentation for depositors using the Deposit Service</a> to find out how to use the Deposit Service to transfer digital files to Cambridge University Libraries.
    </p>
    <p>Contact <a href="mailto:digitalpreservationservice@lib.cam.ac.uk">digitalpreservationservice@lib.cam.ac.uk</a> with questions.</p>
    <p>There is separate guidance for archivists using the Deposit Service but it is not available online because it contains internal information.</p>
    <br>
  </v-card>
</template>

<script>
  import '@/styles/rich-text.css'

  export default {
    name: 'HelpPage',
  }
</script>
